import { Autocomplete, Box, Button, CircularProgress, FormControl, FormHelperText, Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';

const CancellForm = ({onClose,onCancel}) => {
    const { control, handleSubmit, formState: { isDirty} } = useForm({
        mode: "onChange",
        defaultValues:{
            message:'',
            cancelBy:''
        }
      });

      const onSubmit=async(data)=>{
        // console.log("requiredData",data);
        onClose(data);
        
    }
    return (
        <Box component={'form'} onSubmit={handleSubmit(onSubmit)}>
            <Grid item xs={12} sm={6} sx={{display:'flex',gap:1}}>
                <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins',flex:1}}>Cancel By<span style={{color:'#d32f2f'}}>*</span></Typography>
                <FormControl size="small" sx={{flex:2}} >
                    <Controller
                        name="cancelBy"
                        control={control}
                        rules={{
                            required: 'Select Cancel By',
                        }}
                        render={({ field,fieldState:{error} }) => (
                        <Select
                            {...field}
                            sx={{
                                minHeight: '0px',
                                height: '1.6rem',
                                fontSize: '0.65rem',
                                // fontWeight: '600',
                                '& .MuiSelect-select': {
                                    padding: '0 .5rem', // Adjust horizontal padding as needed
                                    display: 'flex',
                                    alignItems: 'center',
                                },
                            }}
                            error={!!error}
                        >
                            
                            <MenuItem sx={{fontSize:'0.65rem'}} value='admin'>Admin</MenuItem>
                            <MenuItem sx={{fontSize:'0.65rem'}} value='customer'>Customer</MenuItem>
                            <MenuItem sx={{fontSize:'0.65rem'}} value='expert'>Service Expert</MenuItem>
                        </Select>
                        )}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={12} sx={{my:'1%'}}>
                <Typography sx={{fontWeight:'600',fontSize:'0.85rem',fontFamily: 'Poppins'}}>Reason for Cancellation<span style={{color:'#d32f2f'}}>*</span></Typography>
                <Controller
                    control={control}
                    name="message"
                    rules={{
                        required: 'Enter Reason for Cancellation',
                    }}
                    render={({ field, fieldState: { error } }) => (
                        <TextField
                            {...field}
                            // label="Reason for Cancellation*"
                            fullWidth
                            multiline
                            rows={3}
                            error={!!error}
                            helperText={error ? error.message : null}
                            variant="outlined"
                            size="small"
                            inputProps={{
                                style: { fontSize: '0.75rem' },
                            }}
                        />
                    )}
                    
                />
            </Grid>
            <Box sx={{display:'flex',justifyContent:'flex-end',gap:2}}>
                <Button variant='outlined' size='small' onClick={onCancel}>Cancel</Button>
                <Button variant='contained' size='small' type="submit" disabled={!isDirty} >Submit</Button>
            </Box>
        </Box>
    );
}

export default CancellForm;
